import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { plainToClass } from 'class-transformer';

import { environment } from '../../../environments/environment';
import { ProgressIndicatorService } from './progress-indicator.service';
import { CollectApiServiceBase } from './collect-api-base.service';
import { Form } from '../models/form-builder/form.model';
import { SiteHomePage } from '../models/form-builder/site-home-page.model';

@Injectable()
export class SiteHomePageService extends CollectApiServiceBase<SiteHomePage> {
    // Constructor.
    public constructor(http: HttpClient, progressIndicatorService: ProgressIndicatorService) {
        super(http, progressIndicatorService, environment.apiUrl, 'siteHomePage', SiteHomePage);
    }

    // Overrides.
    public formatResponse(data: SiteHomePage): SiteHomePage {
        let obj = plainToClass(SiteHomePage, data);

        return (obj);
    }

    // Service methds.
    public get(id: number): Promise<SiteHomePage> {
        let result = super.get(id);
        return result;
    }

    public save(data: SiteHomePage): Promise<SiteHomePage> {
        let result: Promise<SiteHomePage> = null;

        if (data.id > 0) {
            result = this.update(data);
        } else {
            result = this.create(data);
        }

        return result;
    }

}
